<!-- NAVBAR + HERO (share one flat surface) -->
<div class="aic-hero-band position-relative overflow-hidden d-flex flex-column min-vh-100 bg-white">
  <NavbarSection />
  <HeroSection />
</div>

<FeatureSection />

<FooterSection />
